import React from 'react';
import { FileCheck2Icon, GiftIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
const reassurances = [{
  icon: ZapIcon,
  label: 'Simple refund'
}, {
  icon: FileCheck2Icon,
  label: 'No forms to fill out'
}, {
  icon: GiftIcon,
  label: 'You keep the bonuses'
}];
export function GuaranteeSection() {
  return <section className="bg-stone-100 px-5 py-20" data-id="element-71" data-mp="eu8w186t7gj9">
      <div className="mx-auto max-w-3xl border border-line bg-white p-8 text-center sm:p-14" data-id="element-72" data-mp="jsipnecvy92r">
        <p className="inline-flex items-center gap-2 bg-sage-600 px-4 py-2 text-[11px] font-semibold uppercase tracking-[.2em] text-white" data-id="element-73" data-mp="nu4b3o3hjvok">
          <ShieldCheckIcon className="h-4 w-4" data-id="element-74" data-mp="slvrj5sxgl0z" />
          Zero risk · 100% protected
        </p>
        <h2 className="mt-8 font-display text-[2.4rem] font-semibold uppercase leading-[1] tracking-[.01em] text-ink-900 sm:text-5xl" data-id="element-75" data-mp="xivxzhtovpsm">
          The Coach’s Honor
          <span className="block font-medium normal-case italic tracking-normal text-clay-500" data-id="element-76" data-mp="17i4r68gqd0dx">
            7-day guarantee
          </span>
        </h2>
        <p className="mx-auto mt-6 max-w-lg text-base text-ink-600" data-id="element-77" data-mp="25ti4sg7ruiyf">
          Download everything. Use the system in your sessions.
        </p>
        <p className="mx-auto mt-5 max-w-xl text-xl font-medium leading-snug text-ink-900 sm:text-2xl" data-id="element-78" data-mp="1vtrbghuy69zx">
          If Functional Ready™ doesn’t save you hours of planning and elevate
          your professional status,{' '}
          <span className="text-clay-500" data-id="element-79" data-mp="2oiofbfyew495">
            we refund every cent — no questions asked.
          </span>
        </p>
        <p className="mt-4 text-sm text-ink-600" data-id="element-80" data-mp="2jkmzr5072n2f">
          You keep the bonuses as our gift for trying.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-3 text-xs font-medium text-ink-800" data-id="element-81" data-mp="2eqsie882ak6i">
          {reassurances.map(({
          icon: Icon,
          label
        }) => <span key={label} className="flex items-center gap-1.5" data-id="element-82" data-mp="379xyyi1wc9eg">
              <Icon className="h-4 w-4 text-sage-600" data-id="element-83" data-mp="32ifx7rs1u4sf" />
              {label}
            </span>)}
        </div>
      </div>
    </section>;
}